// extracted by mini-css-extract-plugin
export default {"wrapper":"LastInvoices_wrapper__MN8BP","container":"LastInvoices_container__CS1od"};